import type { FaireProductEntity } from "../../entity_types/product";

export const p_sueby92439: FaireProductEntity = {
  token: "p_sueby92439",
  type: "product",
  name: "Boo Trick or Treat Patch Halloween Tote - Kids Acessories",
  brandToken: "b_gro99lye",
  brandName: "Sweet Wink",
  imageUrl:
    "https://cdn.faire.com/fastly/e54a36b94b216361ee7749524cfa5baa3bf04192746ee8480fe2ad376685e215.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/0fe93bdeef51b4c4ff7bdac0ae3968eaeb04390189cb9a467ae12d195bed86fb.jpeg",
    "https://cdn.faire.com/fastly/302d4ec58480cae54d0a44fddc040bdb366991fcdfc23b07d055868741dbc465.jpeg",
    "https://cdn.faire.com/fastly/3a1eaef428d0e8dddd4d2fcff2660e2cd4303a1ff73b8b5c72960236fcdfe180.jpeg",
    "https://cdn.faire.com/fastly/1557eaa250f42849bed2408313711f5872710f0efed062be71ded70cbd81d6c2.jpeg",
  ],
  priceDollars: 10,
  description:
    "Carry a little spooky-season fun wherever you go with this festive tote, perfect for trick-or-treat treasures, library books and all your fall adventures.\n\nFeatures:\n * Tote Color: Lavender \n * Material: 100% Cotton \n * Size: 15’’L x 16’’H \n * Care: Spot clean only \n\nEach tote bag is hand pressed with love in our hometown warehouse.",
  tags: [],
  msrpDollars: 20,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-11T03:44:20.452Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
